import AOS from 'aos';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from './breakpoints';

const selectors = {
  mainCarousel: '[data-splide-carousel]',
};

const initCarousel = (el, options = {}, replaceOptions = false) => {
  const carousel = el.querySelector(selectors.mainCarousel);
  let carouselOptions = {};

  if (carousel) {
    carouselOptions = {
      perPage: 1,
      perMove: 1,
      pagination: false,
      gap: '1rem',
      padding: { left: 0, right: 40 },
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.md]: {
          perPage: 3,
          padding: '0',
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
          padding: '0',
        },
      },
      ...options,
    };

    if (replaceOptions) {
      carouselOptions = options;
    }

    const splide = new Splide(carousel, carouselOptions).mount();

    if (splide.length <= splide.options.perPage) {
      splide.options = {
        arrows: false,
      };
    }

    splide.on('hidden', () => {
      if (splide.length > splide.options.perPage) {
        splide.options = {
          arrows: true,
        };
      }
    });
    splide.on('visible', () => {
      if (splide.length <= splide.options.perPage) {
        splide.options = {
          arrows: false,
        };
      }
    });

    AOS.refresh();
  }
};

export default initCarousel;
